import { DATA_ROOM_ALLOWED_EXTENSIONS, DATA_ROOM_ALLOWED_MIME_TYPES } from 'src/enviroment/constants/constants'
import { fileExtension } from './fileExtension'

/** True when the file's MIME type or extension is one the data room accepts. */
export const isValidFile = (file: File): boolean => {
  const ext = fileExtension(file.name)
  return (
    DATA_ROOM_ALLOWED_MIME_TYPES.includes(file.type) || (ext !== null && DATA_ROOM_ALLOWED_EXTENSIONS.includes(ext))
  )
}
